import GLightbox from 'glightbox'

export function lightbox() {
	const lightbox = GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: false,
		openEffect: 'fade',
		closeEffect: 'fade',
	})

	const openMobileLightboxes = document.querySelectorAll('.openMobileLightbox')
	if (openMobileLightboxes.length) {
		openMobileLightboxes.forEach((openMobileLightbox) => {
			openMobileLightbox.addEventListener('click', (e) => {
				const galleryItem = e.target.closest('.openMobileLightbox') || e.target
				const galleryName = galleryItem.getAttribute('data-gallery-name')
				const galleryLink = galleryItem.getAttribute('data-href')

				if (!galleryName || !galleryLink) return

				const targetItem = document.querySelector(`[data-gallery='${galleryName}'][href='${galleryLink}']`)
				if (targetItem) {
					lightbox.open(targetItem)
				}
			})
		})
	}
}
